import { FlexibleDisplayItem } from '@chiroup/core/functions/buildFlexibleDisplay';
import { ComplaintSummaryType, QuestionAnswer } from '@chiroup/core/types/ComplaintSummary.type';
import React from 'react';
import TemplateWithInteractiveElements from './TemplateWithInteractiveElements';

interface FlexibleDisplayItemRendererProps {
  item: FlexibleDisplayItem;
  itemIndex: number;
  sectionTitle?: string;
  questionAnswerMaps: Record<string, QuestionAnswer>;
  isEditable: boolean;
  popoverOpen: Record<string, boolean>;
  onPopoverOpenChange: (uniqueKey: string, open: boolean) => void;
  onAnswerChange: (questionId: string, newValue: string | string[], otherValue?: string) => void;
  onSymptomClick?: (
    questionId: string,
    symptomValue: string | string[],
    otherValue?: string,
    customInputData?: Record<string, string>
  ) => void;
  summaryType?: ComplaintSummaryType;
}

const FlexibleDisplayItemRenderer: React.FC<FlexibleDisplayItemRendererProps> = ({
  item,
  itemIndex,
  sectionTitle,
  questionAnswerMaps,
  isEditable,
  popoverOpen,
  onPopoverOpenChange,
  onAnswerChange,
  onSymptomClick,
  summaryType,
}) => {
  if (item.type === 'nested_section') {
    return (
      <div key={`nested-${itemIndex}`} className="ml-4">
        <strong className="block mb-2">{item.nestedTitle}</strong>
        {item.nestedItems?.map((nestedItem, nestedIndex) => (
          <div key={`nested-item-${nestedIndex}`}>
            <FlexibleDisplayItemRenderer
              item={nestedItem}
              itemIndex={nestedIndex}
              sectionTitle={sectionTitle}
              questionAnswerMaps={questionAnswerMaps}
              isEditable={isEditable}
              popoverOpen={popoverOpen}
              onPopoverOpenChange={onPopoverOpenChange}
              onAnswerChange={onAnswerChange}
              onSymptomClick={onSymptomClick}
              summaryType={summaryType}
            />
          </div>
        ))}
      </div>
    );
  }

  if (item.type === 'text' && item.template && item.questionData) {
    // Special handling for [None] items - apply primary color styling
    if (item.template.includes('[None]') && item.questionId && onSymptomClick) {
      return (
        <div key={`item-${itemIndex}`}>
          <TemplateWithInteractiveElements
            template={item.template}
            questionData={item.questionData}
            questionAnswerMaps={questionAnswerMaps}
            isEditable={isEditable}
            popoverOpen={popoverOpen}
            onPopoverOpenChange={onPopoverOpenChange}
            onAnswerChange={onAnswerChange}
            yellowFlags={item.yellowFlags}
            onSymptomClick={onSymptomClick}
            summaryType={summaryType}
            sectionTitle={sectionTitle}
            itemIndex={itemIndex}
          />
        </div>
      );
    }

    return (
      <div key={`item-${itemIndex}`}>
        <TemplateWithInteractiveElements
          template={item.template}
          questionData={item.questionData}
          questionAnswerMaps={questionAnswerMaps}
          isEditable={isEditable}
          popoverOpen={popoverOpen}
          onPopoverOpenChange={onPopoverOpenChange}
          onAnswerChange={onAnswerChange}
          yellowFlags={item.yellowFlags}
          onSymptomClick={onSymptomClick}
          summaryType={summaryType}
          sectionTitle={sectionTitle}
          itemIndex={itemIndex}
        />
      </div>
    );
  }

  return null;
};

export default FlexibleDisplayItemRenderer;
